import clsx from "clsx";
import { LandingTestimonials } from "./LandingTestimonials";
import { LandingImageBar } from "./LandingImageBar";
import { LandingTextImageContent } from "./LandingTextImageContent";
import { LandingCustomers } from "./LandingCustomers";
import { LandingButtonGrid } from "./LandingButtonGrid";
import { LandingCtaBar } from "./LandingCtaBar";

export const LandingMainContent = ({ data }) => {
  return (
    <>
      {data.map((component, componentIndex) => (
        <div
          className={clsx(
            "LandingMainContent",
            `LandingMainContent-${component.type}`,
            component.fields?.background_color &&
              `LandingMainContent-background-${component.fields?.background_color}`,
            component.fields?.align && `LandingMainContent-align-${component.fields?.align}`,
          )}
          id={`main_${componentIndex + 1}`}
          key={componentIndex}
        >
          {component.type === "customers" && <LandingCustomers data={component} />}
          {component.type === "text_image" && <LandingTextImageContent data={component} />}
          {component.type === "button_grid" && <LandingButtonGrid data={component} />}
          {component.type === "image_bar" && <LandingImageBar data={component} />}
          {component.type === "cta_bar" && <LandingCtaBar data={component} />}
          {component.type === "testimonials" && (
            <LandingTestimonials testimonials={component?.fields?.testimonials} />
          )}
        </div>
      ))}
    </>
  );
};
